import { fork, put, takeEvery, all } from 'redux-saga/effects';
import {
  CreateAccountReq,
  EmailCheckReq,
  ManagerApi,
  ManagerControllerDtoCreateAccountRequest,
  ManagerControllerDtoEmailCheckRequest,
  ManagerControllerDtoManagerInfoUpdateRequest,
  ManagerControllerDtoManagerListRequest,
  ManagerControllerDtoManagerSecedeRequest,
  ManagerControllerDtoManagerTerminateSessionRequest,
  ManagerControllerDtoManagerViewRequest,
  ManagerControllerDtoRemoveTwoFactorRequest,
  ManagerControllerDtoRndChangePasswordRequest,
  ManagerInfoUpdateReq,
  ManagerListReq,
  ManagerSecedeReq,
  ManagerTerminateSessionReq,
  ManagerViewReq,
  RemoveTwofactorReq,
  RndChangePasswordReq,
} from '../../models/src';
import config from '../../../config/config';
import {
  AUTHGROUP_LIST_REQUEST,
  CREATE_ACCOUNT,
  DEPARTMENT_LSIT_REQUEST,
  EMAIL_CHECK,
  MANAGER_INFO_REQUEST,
  MANAGER_INFO_UPDATE,
  MANAGER_LIST_REQUEST,
  MANAGER_SECEDE,
  MANAGER_TERMINATE_SESSION,
  REMOVE_TWOFACTOR,
  RND_CHANGE_PASSWORD,
} from '../../constants/backoffice/managerConstants';
import {
  managerResponseMessage,
} from '../../actions/backoffice/managerActions';
import BaseResponse from '../../models/src/model/BaseResponse';
import ManagerControllerDtoManagerListResponse from '../../models/src/model/ManagerControllerDtoManagerListResponse';
import ManagerControllerDtoManagerViewResponse from '../../models/src/model/ManagerControllerDtoManagerViewResponse';
import ManagerControllerDtoAuthorizationGroupListResponse
  from '../../models/src/model/ManagerControllerDtoAuthorizationGroupListResponse';
import ManagerControllerDtoDepartmentListResponse
  from '../../models/src/model/ManagerControllerDtoDepartmentListResponse';
import ManagerControllerDtoEmailCheckResponse from '../../models/src/model/ManagerControllerDtoEmailCheckResponse';
import ManagerControllerDtoCreateAccountResponse
  from '../../models/src/model/ManagerControllerDtoCreateAccountResponse';
import { getErrorMessage } from '../../../utils/serverErrorCheck';

const api = new ManagerApi(config.API_CLIENT);

// function getUrlVars() {
//   const vars = {};
//   const parts = window.location.href.replace(
//     /[?&]+([^=&]+)=([^&]*)/gi,
//     function (m, key, value) {
//       // eslint-disable-line
//       vars[key] = value;
//     },
//   );
//   return vars;
// }

//= ====================================
//  WATCHERS
//-------------------------------------
function* managerListSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    managerResponseMessage(null, null);
    const requestData = new ManagerControllerDtoManagerListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.searchString = payload.searchString;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiManagerManagerListPost({ managerControllerDtoManagerListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, ManagerControllerDtoManagerListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* managerInfoSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new ManagerControllerDtoManagerViewRequest();
    requestData.managerNo = payload.managerNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiManagerManagerViewPost({ managerControllerDtoManagerViewRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, ManagerControllerDtoManagerViewResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* authGroupListSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const result = yield api.apiManagerAuthorizationGroupListPost(() => {});
    const data = api.apiClient.deserialize(result, ManagerControllerDtoAuthorizationGroupListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* departmentListSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const result = yield api.apiManagerDepartmentListPost(() => {});
    const data = api.apiClient.deserialize(result, ManagerControllerDtoDepartmentListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* emailCheckSaga(payload) {
  try {
    const requestData = new ManagerControllerDtoEmailCheckRequest();
    requestData.email = payload.email;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiManagerEmailCheckPost({ managerControllerDtoEmailCheckRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, ManagerControllerDtoEmailCheckResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* createAccountSaga(payload) {
  try {
    const requestData = new ManagerControllerDtoCreateAccountRequest();
    requestData.name = payload.name;
    requestData.email = payload.email;
    requestData.groupNo = payload.groupNo;
    requestData.departmentNo = payload.departmentNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiManagerCreateAccountPost({ managerControllerDtoCreateAccountRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, ManagerControllerDtoCreateAccountResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* rndChangePasswordSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new ManagerControllerDtoRndChangePasswordRequest();
    requestData.managerNo = payload.managerNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiManagerRndChangePasswordPost({ managerControllerDtoRndChangePasswordRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* removeTwoFactorSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new ManagerControllerDtoRemoveTwoFactorRequest();
    requestData.managerNo = payload.managerNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiManagerRemoveTwofactorPost({ managerControllerDtoRemoveTwoFactorRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* managerSecedeSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new ManagerControllerDtoManagerSecedeRequest();
    requestData.managerNo = payload.managerNo;
    console.log('요청 데아터: ', requestData);

    const result = yield api.apiManagerManagerSecedePost({ managerControllerDtoManagerSecedeRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* managerInfoUpdateSaga(payload) {
  try {
    const requestData = new ManagerControllerDtoManagerInfoUpdateRequest();
    requestData.managerNo = payload.managerNo;
    requestData.name = payload.name;
    requestData.email = payload.email;
    requestData.groupNo = payload.groupNo;
    requestData.departmentNo = payload.departmentNo;
    requestData.enabled = payload.enabled;
    console.log('requestData: ', requestData);
    const result = yield api.apiManagerManagerInfoUpdatePost(
      { managerControllerDtoManagerInfoUpdateRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log(data);
    if (data.resultCode !== 200) {
      throw Error(`Error: ${data.resultCode}( code: ${data.code})`);
    }
    yield put(managerResponseMessage(data.resultCode, '변경 성공'));
    if (payload.callback) {
      payload.callback();
    }
    // if (data.resultCode === 200) {
    //   yield put(managerResponseMessage(data.resultCode, '변경 성공'));
    // } else {
    //   yield put(managerResponseMessage(data.resultCode, '변경 실패'));
    // }
    // managerResponseMessage(null, null);
  } catch (e) {
    console.error(e);
    if (payload.error) {
      payload.error(e);
    }
  } finally {
    managerResponseMessage(null, null);
  }
}

function* managerTerminateSessionSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new ManagerControllerDtoManagerTerminateSessionRequest();
    requestData.managerNo = payload.managerNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiManagerManagerTerminateSessionPost({ managerControllerDtoManagerTerminateSessionRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* managerRootSaga() {
  yield all([
    takeEvery(MANAGER_LIST_REQUEST, managerListSaga),
    takeEvery(MANAGER_INFO_REQUEST, managerInfoSaga),
    takeEvery(AUTHGROUP_LIST_REQUEST, authGroupListSaga),
    takeEvery(DEPARTMENT_LSIT_REQUEST, departmentListSaga),
    takeEvery(EMAIL_CHECK, emailCheckSaga),
    takeEvery(CREATE_ACCOUNT, createAccountSaga),
    takeEvery(RND_CHANGE_PASSWORD, rndChangePasswordSaga),
    takeEvery(REMOVE_TWOFACTOR, removeTwoFactorSaga),
    takeEvery(MANAGER_INFO_UPDATE, managerInfoUpdateSaga),
    takeEvery(MANAGER_SECEDE, managerSecedeSaga),
    takeEvery(MANAGER_TERMINATE_SESSION, managerTerminateSessionSaga),
  ]);
}

const managerSagas = [fork(managerRootSaga)];

export default managerSagas;
